export const SHARE_PATH_PREFIX = {
    photo: '/share/p/',
    video: '/share/v/',
};
export function buildSharePath(kind, id) {
    return `${SHARE_PATH_PREFIX[kind]}${id}`;
}
export function parseSharePath(path) {
    const photo = path.match(/^\/share\/p\/([A-Za-z0-9_-]+)$/);
    if (photo && photo[1])
        return { kind: 'photo', id: photo[1] };
    const video = path.match(/^\/share\/v\/([A-Za-z0-9_-]+)$/);
    if (video && video[1])
        return { kind: 'video', id: video[1] };
    return null;
}
export const ALLOWED_PHOTO_CONTENT_TYPES = ['image/jpeg'];
export const ALLOWED_VIDEO_CONTENT_TYPES = [
    'video/mp4',
    'video/webm',
];
export function isAllowedContentType(kind, contentType) {
    if (kind === 'photo') {
        return ALLOWED_PHOTO_CONTENT_TYPES.includes(contentType);
    }
    return ALLOWED_VIDEO_CONTENT_TYPES.includes(contentType);
}
export const ALL_CAPTURE_MODES = [
    'single',
    'strip3',
    'strip4',
    'video',
];
export const ALL_EFFECT_IDS = [
    'normal',
    'sepia',
    'bw',
    'thermal',
    'xray',
    'comic',
    'pencil',
    'glow',
    'plastic',
    'bugout',
    'twirl',
    'squeeze',
    'mirror',
    'lovestruck',
    'dizzy',
    'sunglasses',
    'tiara',
    'halo',
    'puppy',
    'cat',
    'lashes',
    'eyeBig',
    'smooth',
];
/** Recommended share-image dimensions (standard Open Graph). */
export const SHARE_IMAGE_TARGET = { width: 1200, height: 630 };
/**
 * Format a booth title with the "Photobooth by Ofunc" branding suffix and
 * truncate so the final string fits comfortably in OG title (≤60 chars).
 *
 *   "Ray's birthday booth" → "Ray's birthday booth — Photobooth by Ofunc"
 */
export function brandedBoothTitle(title, maxTotal = 60) {
    const suffix = ' — Photobooth by Ofunc';
    const maxTitle = Math.max(8, maxTotal - suffix.length);
    const t = title.trim();
    const head = t.length <= maxTitle ? t : t.slice(0, maxTitle - 1).trimEnd() + '…';
    return head + suffix;
}
export const PRINT_FRAME_MODES = [
    'single',
    'strip3',
    'strip4',
];
/**
 * Recommended print-frame canvas size for each mode. Builders crop user
 * uploads to these dimensions so the composite at capture time can place
 * the frame deterministically without further resizing.
 */
export const PRINT_FRAME_TARGET = {
    single: { width: 1080, height: 1080 },
    strip3: { width: 1080, height: 3480 },
    strip4: { width: 1080, height: 4700 },
};
// --- Booth path helpers ---
export function buildBoothGalleryPath(slug) {
    return `/${slug}/gallery`;
}
// --- Slug validation (shared between web and api) ---
export const SLUG_MIN_LEN = 3;
export const SLUG_MAX_LEN = 40;
export const SLUG_REGEX = /^[a-z0-9](?:[a-z0-9-]{1,38}[a-z0-9])?$/;
/**
 * Paths that must never be treated as booth slugs because they collide with
 * site infrastructure. The API rejects creates against these and the web app
 * skips manifest lookup for them.
 */
export const RESERVED_SLUGS = new Set([
    'api',
    'assets',
    'builder',
    'favicon.svg',
    'index.html',
    'mediapipe',
    'og.png',
    'og.svg',
    'robots.txt',
    'share',
    'sitemap.xml',
    'static',
    'uploads',
    '_next',
]);
export function isValidSlug(slug) {
    if (typeof slug !== 'string')
        return false;
    if (slug.length < SLUG_MIN_LEN || slug.length > SLUG_MAX_LEN)
        return false;
    if (!SLUG_REGEX.test(slug))
        return false;
    if (RESERVED_SLUGS.has(slug))
        return false;
    return true;
}
// --- Share-page path helpers for booth-scoped shares ---
export function buildBoothSharePath(slug, kind, id) {
    const k = kind === 'photo' ? 'p' : 'v';
    // We keep booth shares under `/share/` so CloudFront's existing
    // `/share/p/*` and `/share/v/*` cache behaviors route them straight to
    // API Gateway without needing a regex-rewrite.
    return `/share/${k}/${slug}/${id}`;
}
export function parseBoothSharePath(path) {
    const m = path.match(/^\/share\/(p|v)\/([a-z0-9-]+)\/([A-Za-z0-9_-]+)$/);
    if (!m || !m[1] || !m[2] || !m[3])
        return null;
    if (RESERVED_SLUGS.has(m[2]))
        return null;
    return {
        slug: m[2],
        kind: m[1] === 'p' ? 'photo' : 'video',
        id: m[3],
    };
}
//# sourceMappingURL=index.js.map